import { render, staticRenderFns } from "./traineeDesignation.vue?vue&type=template&id=db0ac3ea&scoped=true"
import script from "./traineeDesignation.vue?vue&type=script&lang=js"
export * from "./traineeDesignation.vue?vue&type=script&lang=js"
import style0 from "./traineeDesignation.vue?vue&type=style&index=0&id=db0ac3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0ac3ea",
  null
  
)

export default component.exports